/* eslint max-classes-per-file: 0 */

import { User, UserCollection } from '@/typings/api/User'
import { UsersApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<User, UserCollection>()

export class UsersTransformerParams extends TransformerParams {
  protected delete_multiple_param = 'user_ids';

  public getAll(payload: Record<string, unknown>, rawParams: Record<string, unknown>) {
    const result = super.getAll(payload, rawParams)
    const p = result.params as Record<string, Record<string, unknown>>

    const params = {
      ...p,
      timezone_id: p.timezone?.id as number,
      timezone: void 0,

      region_id: p.region?.id as number,
      region: void 0,

      municipality_id: p.municipality?.id as number,
      municipality: void 0,

      school_id: p.school?.id as number,
      school: void 0,

      is_active: p.is_active?.value,
    }

    return { ...result, params }
  }
}

export class UsersAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new UsersTransformerParams();
}
